module.exports = __webpack_public_path__ + "images/marketing/2013-bg.jpg";